// ChatWorkspace 本体(assistant-ui 一式)を含まない、パネルの開閉状態・設定配布だけの
// 軽量な入口。開閉トリガ(「AIに相談」ボタン等)はパネル本体と別の場所でレンダリングされるため、
// パネルの完全な依存グラフを引き込まずに済むよう index.ts とは別の subpath を切っている。
export * from "./ai-chat-context";
export * from "./chat-config";
export * from "./agent-api";
